<template>
	<div>
		<vs-alert color="danger" title="Dymo foutmelding" active="true" class="mb-5">
			Momenteel ervaren wij problemen met de nieuwste versie van Dymo op windows. We werken samen met Dymo aan een oplossing. Advies is op dit moment om GEEN updates van
			Dymo te installeren die hoger zijn dan Dymo Connect V1.3.2.14.<br>
		</vs-alert>
		<div v-if="connectionFailed" class="vx-col w-full mb-base">
			<vx-card title="Verbinding met Dymo mislukt">
				Er is geen verbinding met Dymo Label Web Service mogelijk!<br>
				<br>
				Door op de 'Check'-knop te klikken kun je controleren of deze aan staat. Er opent een nieuw tabblad waarin een groene tekst hoort
				te verschijnen.<br>
				<br>
				<vs-button target="_blank" href="https://127.0.0.1:41951/DYMO/DLS/Printing/Check"> Check</vs-button>
				<br>
				<br>
				<b>Er staat geen groene tekst</b> <br>
				<br>
				<b>Voor Windows</b><br>
				Start 'dymo.DLS.Printing.Host', dit kan door op de 'Windows'-toets
				te drukken en 'dymo.DLS.Printing.Host' in te typen. Daarna kun je op de 'Enter'-toets drukken.<br>
				<br>
				<b>Voor Mac-OS</b><br>
				Start 'dymo.DLS.Printing.Host', dit kan door op 'Command'-toets + 'Spatie'-toets te drukken
				en 'dymo.DLS.Printing.Host' in te typen. Daarna kun je op de 'Enter'-toets drukken.<br>
				Of open een terminal en voer <code>launchctl start com.dymo.dls.webservice</code> uit.
				<br>
				<br>
				Als laatste moet je de pagina herladen.<br>
				<br>
				<vs-button color="success" type="border" target="_blank" @click.native="reloadPage">Pagina
					Herladen
				</vs-button>
			</vx-card>
		</div>

		<div v-if="!addressPrinter.loading" class="vx-col w-full mb-base">
			<vx-card title="Adres labelprinter" loading="true">
				<template slot="actions">
					<vx-tooltip class="flex" text="Hoe en wat?">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>
				<div class="vx-row mb-6 ">
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labelprinter</label>
								<vue-multiselect
									v-model="addressPrinter.selectedPrinterValue"
									placeholder="Selecteer een labelprinter"
									:options="availableDymoPrintersList"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div v-if="addressPrinter.selectedPrinter !== null && addressPrinter.selectedPrinter.isTwinTurbo" class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een rol</label>
								<vue-multiselect
									v-model="addressPrinter.selectedTwinValue"
									placeholder="Selecteer een rol"
									:options="twinTurboOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labeltype</label>
								<vue-multiselect
									v-model="addressPrinter.selectedLabelValue"
									placeholder="Selecteer een labeltype"
									:options="labelOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<vs-input class="w-full" label="Ondertekst" v-model="addressPrinter.printer.bottom_text"
										  v-on:change="addressRender" />
								<p class="text-sm">Je kan ook het bestelnummer vermelden in de ondertekst. Dit doe je door '%bestelnummer%' erin te zetten.</p>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<vs-checkbox class="inline-flex" v-model="addressPrinter.printer.postnl_port_stamp"
											 v-on:change="addressRender">Port betaald
								</vs-checkbox>
							</div>
						</div>
					</div>
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<img v-if="addressPrinter.image" :src="addressPrinter.image" style="width: 100%; object-fit: cover;" />
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col vs-xs-12 vs-sm-12 vs-lg-12">
						<vs-button color="primary" type="filled" id="address-save-with-loading" @click.native="addressSave()">Opslaan</vs-button>
						<vs-button color="primary" type="border" id="address-print-with-loading" @click.native="addressPrint()" class="ml-2">Voorbeeld
							printen
						</vs-button>
					</div>
				</div>
			</vx-card>
		</div>

		<div v-if="!productPrinter.loading" class="vx-col w-full mb-base">
			<vx-card title="Product labelprinter" loading="true">
				<template slot="actions">
					<vx-tooltip class="flex" text="Hoe en wat?">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>
				<div class="vx-row mb-6 ">
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labelprinter</label>
								<vue-multiselect
									v-model="productPrinter.selectedPrinterValue"
									placeholder="Selecteer een labelprinter"
									:options="availableDymoPrintersList"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div v-if="productPrinter.selectedPrinter !== null && productPrinter.selectedPrinter.isTwinTurbo" class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een rol</label>
								<vue-multiselect
									v-model="productPrinter.selectedTwinValue"
									placeholder="Selecteer een rol"
									:options="twinTurboOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labeltype</label>
								<vue-multiselect
									v-model="productPrinter.selectedLabelValue"
									placeholder="Selecteer een labeltype"
									:options="labelOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<vs-input class="w-full" label="Ondertekst" v-model="productPrinter.printer.bottom_text"
										  v-on:change="productRender" />
							</div>
						</div>
					</div>
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<img v-if="productPrinter.image" :src="productPrinter.image" style="width: 100%; object-fit: cover;" />
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col vs-xs-12 vs-sm-12 vs-lg-12">
						<vs-button color="primary" type="filled" id="product-save-with-loading" @click.native="productSave()">Opslaan</vs-button>
						<vs-button color="primary" type="border" id="product-print-with-loading" @click.native="productPrint()" class="ml-2">Voorbeeld printen</vs-button>
					</div>
				</div>
			</vx-card>
		</div>

		<div v-if="!returnPrinter.loading" class="vx-col w-full mb-base">
			<vx-card title="Retour labelprinter" loading="true">
				<template slot="actions">
					<vx-tooltip class="flex" text="Hoe en wat?">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>
				<div class="vx-row mb-6 ">
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labelprinter</label>
								<vue-multiselect
									v-model="returnPrinter.selectedPrinterValue"
									placeholder="Selecteer een labelprinter"
									:options="availableDymoPrintersList"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div v-if="returnPrinter.selectedPrinter !== null && returnPrinter.selectedPrinter.isTwinTurbo" class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een rol</label>
								<vue-multiselect
									v-model="returnPrinter.selectedTwinValue"
									placeholder="Selecteer een rol"
									:options="twinTurboOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labeltype</label>
								<vue-multiselect
									v-model="returnPrinter.selectedLabelValue"
									placeholder="Selecteer een labeltype"
									:options="labelOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<vs-input class="w-full" label="Ondertekst" v-model="returnPrinter.printer.bottom_text"
										  v-on:change="returnRender" />
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<vs-textarea class="w-full" label="Retouradres" v-model="returnPrinter.printer.retour_address"
											 v-on:change="returnRender" />
							</div>
						</div>
					</div>
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<img v-if="returnPrinter.image" :src="returnPrinter.image" style="width: 100%; object-fit: cover;" />
					</div>

				</div>
				<div class="vx-row">
					<div class="vx-col vs-xs-12 vs-sm-12 vs-lg-12">
						<vs-button color="primary" type="filled" id="return-save-with-loading" @click.native="returnSave()">Opslaan</vs-button>
						<vs-button color="primary" type="border" id="return-print-with-loading" @click.native="returnPrint()" class="ml-2">Voorbeeld printen</vs-button>
					</div>
				</div>
			</vx-card>
		</div>

		<div v-if="!eanPrinter.loading" class="vx-col w-full mb-base">
			<vx-card title="Ean labelprinter" loading="true">
				<template slot="actions">
					<vx-tooltip class="flex" text="Hoe en wat?">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>
				<div class="vx-row mb-6 ">
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labelprinter</label>
								<vue-multiselect
									v-model="eanPrinter.selectedPrinterValue"
									placeholder="Selecteer een labelprinter"
									:options="availableDymoPrintersList"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div v-if="eanPrinter.selectedPrinter !== null && eanPrinter.selectedPrinter.isTwinTurbo" class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een rol</label>
								<vue-multiselect
									v-model="eanPrinter.selectedTwinValue"
									placeholder="Selecteer een rol"
									:options="twinTurboOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
						<div class="vx-row mb-6">
							<div class="vx-col w-full">
								<label class="multiselect-label">Selecteer een labeltype</label>
								<vue-multiselect
									v-model="eanPrinter.selectedLabelValue"
									placeholder="Selecteer een labeltype"
									:options="eanLabelOptions"
									:allow-empty="false"
									:show-labels="false"
									label="label"
									track-by="id"
								/>
							</div>
						</div>
					</div>
					<div class="vx-col vs-xs-12 vs-sm-6 vs-lg-6">
						<img v-if="eanPrinter.image" :src="eanPrinter.image" style="width: 100%; object-fit: cover;" />
					</div>
				</div>
				<div class="vx-row">
					<div class="vx-col vs-xs-12 vs-sm-12 vs-lg-12">
						<vs-button color="primary" type="filled" id="ean-save-with-loading" @click.native="eanSave()">Opslaan</vs-button>
						<vs-button color="primary" type="border" id="ean-print-with-loading" @click.native="eanPrint()" class="ml-2">Voorbeeld printen</vs-button>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>

import dymoLabels from '@/services/dymo/dymoLabels';
import dymoPrinter from '@/services/dymo/dymoPrinter';


export default {
	name: 'module-printing-dymo',
	data() {
		return {
			connectionFailed: false,
			availableDymoPrinters: [],
			availableDymoPrintersList: [],
			twinTurboOptions: [
				{
					id: 'Auto',
					label: 'Automatisch kiezen'
				},
				{
					id: 'Left',
					label: 'Links'
				},
				{
					id: 'Right',
					label: 'Rechts'
				},
			],
			labelOptions: [
				{
					id: '30323',
					label: '30323 Shipping'
				},
				{
					id: '30321',
					label: '30321 Large address'
				},
			],
			eanLabelOptions: [
				{
					id: 's0722460',
					label: 's0722460 Ean'
				}
			],
			addressPrinter: {
				loading: true,
				printer: null,
				selectedPrinter: null,
				selectedPrinterValue: null,
				label: dymoLabels.shippingLabel,
				selectedLabelValue: null,
				selectedTwinValue: null,
				image: null,
			},
			productPrinter: {
				loading: true,
				printer: null,
				selectedPrinter: null,
				selectedPrinterValue: null,
				label: dymoLabels.productLabel,
				selectedLabelValue: null,
				selectedTwinValue: null,
				image: null,
			},
			returnPrinter: {
				loading: true,
				printer: null,
				selectedPrinter: null,
				selectedPrinterValue: null,
				label: dymoLabels.returnLabel,
				selectedLabelValue: null,
				selectedTwinValue: null,
				image: null,
			},
			eanPrinter: {
				loading: true,
				printer: null,
				selectedPrinter: null,
				selectedPrinterValue: null,
				label: dymoLabels.eanLabel,
				selectedLabelValue: null,
				selectedTwinValue: null,
				image: null,
			},
		}
	},
	watch: {
		'addressPrinter.selectedPrinterValue'() {
			this.addressPrinter.printer.name = this.addressPrinter.selectedPrinterValue.id;
		},
		'addressPrinter.printer.name'() {
			this.availableDymoPrinters.forEach(printer => {
				if (printer.name === this.addressPrinter.printer.name) {
					this.addressPrinter.selectedPrinter = printer;
					this.addressPrinter.selectedPrinterValue = this.castPrinter(printer.name);
					this.addressPrinter.selectedLabelValue = this.castLabel(this.addressPrinter.printer.label);
					this.addressPrinter.selectedTwinValue = this.castTwinOption(this.addressPrinter.printer.twin_roll);
				}
			});

			if (this.addressPrinter.selectedPrinter) {
				if (this.addressPrinter.selectedPrinter.isTwinTurbo) {
					this.addressPrinter.printer.is_twin = true;
				} else {
					this.addressPrinter.printer.is_twin = false;
					this.addressPrinter.printer.twin_roll = null;
				}
			}
		},
		'addressPrinter.selectedLabelValue'() {
			this.addressPrinter.printer.label = this.addressPrinter.selectedLabelValue.id;
			this.addressPrinter.label.setLabelType(this.addressPrinter.selectedLabelValue.id);
		},
		'addressPrinter.selectedTwinValue'() {
			this.addressPrinter.printer.twin_roll = this.addressPrinter.selectedTwinValue.id;
		},
		'addressPrinter.printer.label'() {
			this.addressRender();
		},
		'productPrinter.selectedPrinterValue'() {
			this.productPrinter.printer.name = this.productPrinter.selectedPrinterValue.id;
		},
		'productPrinter.printer.name'() {
			this.availableDymoPrinters.forEach(printer => {
				if (printer.name === this.productPrinter.printer.name) {
					this.productPrinter.selectedPrinter = printer;
					this.productPrinter.selectedPrinterValue = this.castPrinter(printer.name);
					this.productPrinter.selectedLabelValue = this.castLabel(this.productPrinter.printer.label);
					this.productPrinter.selectedTwinValue = this.castTwinOption(this.productPrinter.printer.twin_roll);
				}
			});
			if (this.productPrinter.selectedPrinter) {
				if (this.productPrinter.selectedPrinter.isTwinTurbo) {
					this.productPrinter.printer.is_twin = true;
				} else {
					this.productPrinter.printer.is_twin = false;
					this.productPrinter.printer.twin_roll = null;
				}
			}
		},
		'productPrinter.selectedLabelValue'() {
			this.productPrinter.printer.label = this.productPrinter.selectedLabelValue.id;
			this.productPrinter.label.setLabelType(this.productPrinter.selectedLabelValue.id);
		},
		'productPrinter.selectedTwinValue'() {
			this.productPrinter.printer.twin_roll = this.productPrinter.selectedTwinValue.id;
		},
		'productPrinter.printer.label'() {
			this.productRender();
		},
		'returnPrinter.selectedPrinterValue'() {
			this.returnPrinter.printer.name = this.returnPrinter.selectedPrinterValue.id;
		},
		'returnPrinter.printer.name'() {
			this.availableDymoPrinters.forEach(printer => {
				if (printer.name === this.returnPrinter.printer.name) {
					this.returnPrinter.selectedPrinter = printer;
					this.returnPrinter.selectedPrinterValue = this.castPrinter(printer.name);
					this.returnPrinter.selectedLabelValue = this.castLabel(this.returnPrinter.printer.label);
					this.returnPrinter.selectedTwinValue = this.castTwinOption(this.returnPrinter.printer.twin_roll);
				}
			});
			if (this.returnPrinter.selectedPrinter) {
				if (this.returnPrinter.selectedPrinter.isTwinTurbo) {
					this.returnPrinter.printer.is_twin = true;
				} else {
					this.returnPrinter.printer.is_twin = false;
					this.returnPrinter.printer.twin_roll = null;
				}
			}
		},
		'returnPrinter.selectedLabelValue'() {
			this.returnPrinter.printer.label = this.returnPrinter.selectedLabelValue.id;
			this.returnPrinter.label.setLabelType(this.returnPrinter.selectedLabelValue.id);
		},
		'returnPrinter.selectedTwinValue'() {
			this.returnPrinter.printer.twin_roll = this.returnPrinter.selectedTwinValue.id;
		},
		'returnPrinter.printer.label'() {
			this.returnRender();
		},
		'eanPrinter.selectedPrinterValue'() {
			this.eanPrinter.printer.name = this.eanPrinter.selectedPrinterValue.id;
		},
		'eanPrinter.selectedTwinValue'() {
			this.eanPrinter.printer.twin_roll = this.eanPrinter.selectedTwinValue.id;
		},
		'eanPrinter.printer.name'() {
			this.availableDymoPrinters.forEach(printer => {
				if (printer.name === this.eanPrinter.printer.name) {
					this.eanPrinter.selectedPrinter = printer;
					this.eanPrinter.selectedPrinterValue = this.castPrinter(printer.name);
					this.eanPrinter.selectedLabelValue = this.castLabelEan(this.eanPrinter.printer.label);
					this.eanPrinter.selectedTwinValue = this.castTwinOption(this.eanPrinter.printer.twin_roll);
				}
			});

			if (this.eanPrinter.selectedPrinter) {
				if (this.eanPrinter.selectedPrinter.isTwinTurbo) {
					this.eanPrinter.printer.is_twin = true;
				} else {
					this.eanPrinter.printer.is_twin = false;
					this.eanPrinter.printer.twin_roll = null;
				}
			}
		},
		'eanPrinter.selectedLabelValue'() {
			this.eanPrinter.printer.label = this.eanPrinter.selectedLabelValue.id;
			this.eanPrinter.label.setLabelType(this.eanPrinter.selectedLabelValue.id);
		},
		'eanPrinter.printer.label'() {
			this.eanRender();
		},
	},
	mounted() {
		this.$vs.loading();
		this.$store.dispatch('dymoStore/init').then(async res => {
			this.dymoPrinter = new dymoPrinter();
			this.dymoPrinter.init().then(() => {
				this.initPrinters().then(() => {
					this.addressPrinter.printer = {...this.$store.state.dymoStore.dymo.addressPrinter};
					this.productPrinter.printer = {...this.$store.state.dymoStore.dymo.productPrinter};
					this.returnPrinter.printer = {...this.$store.state.dymoStore.dymo.returnPrinter};
					this.eanPrinter.printer = {...this.$store.state.dymoStore.dymo.eanPrinter};

					this.$vs.loading.close();
					this.addressPrinter.loading = false;
					this.productPrinter.loading = false;
					this.returnPrinter.loading = false;
					this.eanPrinter.loading = false;
				});
			}).catch(error => {
				this.connectionFailed = true;
				this.$vs.loading.close();

				this.$vs.notify({
					title: 'Oops!',
					text: 'We kunnen geen verbinding maken met Dymo Label Web Service.',
					color: 'danger'
				});
			});
		});
	},
	methods: {
		initPrinters() {
			return new Promise((resolve, reject) => {
				this.dymoPrinter.getPrinters().then(printers => {
					const printerList = [];

					printers.forEach((printer) => {
						printerList.push({
							id: printer.name,
							label: printer.name + ' ' + (printer.isConnected ? '(Verbonden)' : '(Niet verbonden)')
						});
					});

					this.availableDymoPrinters = printers;
					this.availableDymoPrintersList = printerList;

					resolve();
				});
			});
		},
		castPrinter(printerId) {
			let castedPrinter = null;

			this.availableDymoPrintersList.forEach(printer => {
				if (printer.id === printerId) {
					castedPrinter = printer;
				}
			});

			return castedPrinter;
		},
		castLabel(labelId) {
			let castedLabel = null;

			this.labelOptions.forEach(label => {
				if (label.id === labelId) {
					castedLabel = label;
				}
			});

			return castedLabel;
		},
		castLabelEan(labelId) {
			let castedLabel = null;

			this.eanLabelOptions.forEach(label => {
				if (label.id === labelId) {
					castedLabel = label;
				}
			});

			return castedLabel;
		},
		castTwinOption(twinId) {
			let castedTwin = null;

			this.twinTurboOptions.forEach(twinOption => {
				if (twinOption.id === twinId) {
					castedTwin = twinOption;
				}
			});

			if (castedTwin === null) {
				return this.twinTurboOptions[0];
			}

			return castedTwin;
		},
		addressUpdate() {
			let bottomText = this.addressPrinter.printer.bottom_text;
			bottomText = bottomText.replace('%bestelnummer%', '1234567890');

			this.addressPrinter.label.setOrderFrom(bottomText);
			this.addressPrinter.label.setLabelType(this.addressPrinter.printer.label);
			this.addressPrinter.label.setPostalStamp(this.addressPrinter.printer.postnl_port_stamp);
		},
		addressRender() {
			this.addressUpdate();

			this.dymoPrinter.renderLabel(this.addressPrinter.name, this.addressPrinter.label).then(labelImage => {
				this.addressPrinter.image = 'data:image/png;base64,' + labelImage
			})
		},
		addressPrint() {
			this.$vs.loading({
				container: '#address-print-with-loading',
				scale: 0.45
			});

			this.dymoPrinter.printLabel(this.addressPrinter.printer, this.addressPrinter.label).then(response => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Adres label verzonden naar printer.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#address-print-with-loading > .con-vs-loading');
				}, 300);
			}).catch(error => {
				console.log(error);
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#address-print-with-loading > .con-vs-loading');
				}, 300);
			});
		},
		addressSave() {
			this.$vs.loading({
				container: '#address-save-with-loading',
				scale: 0.45
			});

			this.$store.dispatch('dymoStore/saveAddressPrinter', this.addressPrinter.printer).then(res => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Adres labelprinter instellingen opgeslagen.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#address-save-with-loading > .con-vs-loading');
				}, 300);
			}).catch(err => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#address-save-with-loading > .con-vs-loading');
				}, 300);
			})
		},
		productUpdate() {
			this.productPrinter.label.setCompany(this.productPrinter.printer.bottom_text);
			this.productPrinter.label.setLabelType(this.productPrinter.printer.label);
		},
		productRender() {
			this.productUpdate();

			this.dymoPrinter.renderLabel(this.productPrinter.name, this.productPrinter.label).then(labelImage => {
				this.productPrinter.image = 'data:image/png;base64,' + labelImage
			})
		},
		productPrint() {
			this.$vs.loading({
				container: '#product-print-with-loading',
				scale: 0.45
			});

			this.dymoPrinter.printLabel(this.productPrinter.printer, this.productPrinter.label).then(response => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Adres label verzonden naar printer.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#product-print-with-loading > .con-vs-loading');
				}, 300);
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#product-print-with-loading > .con-vs-loading');
				}, 300);
			});
		},
		productSave() {
			this.$vs.loading({
				container: '#product-save-with-loading',
				scale: 0.45
			});

			this.$store.dispatch('dymoStore/saveProductPrinter', this.productPrinter.printer).then(res => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Product labelprinter instellingen opgeslagen.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#product-save-with-loading > .con-vs-loading');
				}, 300);
			}).catch(err => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#product-save-with-loading > .con-vs-loading');
				}, 300);
			})
		},
		returnUpdate() {
			this.returnPrinter.label.setName(this.returnPrinter.printer.bottom_text);
			this.returnPrinter.label.setAddress(this.returnPrinter.printer.retour_address);
			this.returnPrinter.label.setLabelType(this.returnPrinter.printer.label);
		},
		returnRender() {
			this.returnUpdate();

			this.dymoPrinter.renderLabel(this.returnPrinter.name, this.returnPrinter.label).then(labelImage => {
				this.returnPrinter.image = 'data:image/png;base64,' + labelImage
			})
		},
		returnPrint() {
			this.$vs.loading({
				container: '#return-print-with-loading',
				scale: 0.45
			});

			this.dymoPrinter.printLabel(this.returnPrinter.printer, this.returnPrinter.label).then(response => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Retour label verzonden naar printer.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#return-print-with-loading > .con-vs-loading');
				}, 300);
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#return-print-with-loading > .con-vs-loading');
				}, 300);
			});
		},
		returnSave() {
			this.$vs.loading({
				container: '#return-save-with-loading',
				scale: 0.45
			});

			this.$store.dispatch('dymoStore/saveReturnPrinter', this.returnPrinter.printer).then(res => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Retour labelprinter instellingen opgeslagen.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#return-save-with-loading > .con-vs-loading');
				}, 300);
			}).catch(err => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#return-save-with-loading > .con-vs-loading');
				}, 300);
			})
		},
		reloadPage() {
			window.location.reload()
		},
		eanUpdate() {
			this.eanPrinter.label.setLabelType(this.eanPrinter.printer.label);
		},
		eanRender() {
			this.eanUpdate();

			this.dymoPrinter.renderLabel(this.eanPrinter.printer.name, this.eanPrinter.label).then(labelImage => {
				this.eanPrinter.image = 'data:image/png;base64,' + labelImage
			})
		},
		eanPrint() {
			this.$vs.loading({
				container: '#ean-print-with-loading',
				scale: 0.45
			});

			this.dymoPrinter.printLabel(this.eanPrinter.printer, this.eanPrinter.label).then(response => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Ean label verzonden naar printer.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#ean-print-with-loading > .con-vs-loading');
				}, 300);
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#ean-print-with-loading > .con-vs-loading');
				}, 300);
			});
		},
		eanSave() {
			this.$vs.loading({
				container: '#ean-save-with-loading',
				scale: 0.45
			});

			this.$store.dispatch('dymoStore/saveEanPrinter', this.eanPrinter.printer).then(res => {
				this.$vs.notify({
					title: 'Yes!',
					text: 'Ean labelprinter instellingen opgeslagen.',
					color: 'success'
				});

				setTimeout(() => {
					this.$vs.loading.close('#ean-save-with-loading > .con-vs-loading');
				}, 300);
			}).catch(err => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er ging iets mis, probeer het opnieuw',
					color: 'danger'
				});

				setTimeout(() => {
					this.$vs.loading.close('#ean-save-with-loading > .con-vs-loading');
				}, 300);
			})
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.printers)
		}
	},
}
</script>
